import type { TOC } from '@ember/component/template-only';
import PageError from '../../components/page-error.gts';

interface Signature {
  Args: {};
}

const ExploreRecipeError: TOC<Signature> = <template>
  <PageError
    @title="Failed to load recipe"
    @backRoute="explore"
    @backLabel="Back to explore"
  />
</template>;

export default ExploreRecipeError;
